
    <pp-shell-dialog [title]="data.title | translate">
      <div mat-dialog-content>
        <p>{{(data.description | translate)[data.autoRenew ? "on" : "off"]}}</p>
      </div>
      <div mat-dialog-actions class="actions" align="end">
        <button [disabled]="isLoading" mat-flat-button mat-dialog-close>{{data.cancel | translate}}</button>
        <button (click)="onConfirm()" class="loading-btn" mat-flat-button color="primary">
          {{data.confirm | translate}}
          <mat-spinner *ngIf="isLoading" diameter="18" color="accent"></mat-spinner>
        </button>
      </div>
    </pp-shell-dialog>
  